module.exports = __webpack_public_path__ + "611e6e0fcff6aface2589e2e3237a2dd.svg";